(ns frontend.ui.component.image-cropper.util)

;; Extracted from `frontend.utils` to prevent pulling all its dependencies

(defn- create-canvas
  [width height]
  (let [canvas (js/document.createElement "canvas")]
    (set! (.-width canvas) width)
    (set! (.-height canvas) height)
    canvas))

(defn crop-resize
  [canvas img sx sy sw sh dw dh]
  (-> canvas
      (.getContext "2d")
      (.drawImage img sx sy sw sh 0 0 dw dh))
  canvas)

(defn img->base64
  [canvas]
  (-> canvas
      (.toDataURL "image/png")))

(defn crop-image
  "Return a cropped image as base64 encoded PNG"
  ([img {:keys [_x _y width height] :as cropped-area}]
   (crop-image img cropped-area width height))
  ([img {:keys [x y width height]} resize-width resize-height]
   (let [i (new js/Image)]
     (set! (.-src i) img)
     (-> (create-canvas resize-width resize-height)
         (crop-resize i x y width height resize-width resize-height)
         (img->base64)))))

(defn read-file!
  [atom ^js/File file]
  (let [rdr (new js/FileReader)]
    (try
      (set! (.-onload rdr)
            (fn [e]
              (let [result (->> e
                                .-target
                                .-result)]
                (reset! atom result))))
      (.readAsDataURL rdr file)
      (catch js/Object exp
        (js/console.log "ERROR image-cropper/read-file! : " exp)))))
